var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66699 12H20.3337M18.667 12V18.6667C18.667 19.1087 18.4914 19.5326 18.1788 19.8452C17.8663 20.1577 17.4424 20.3333 17.0003 20.3333H7.00033C6.5583 20.3333 6.13437 20.1577 5.82181 19.8452C5.50925 19.5326 5.33366 19.1087 5.33366 18.6667V12M5.33366 8.66667L18.667 5.33333M9.38366 7.65004L9.00866 6.1417C8.95493 5.9294 8.94357 5.70858 8.97523 5.49188C9.00689 5.27518 9.08094 5.06685 9.19316 4.87878C9.30538 4.69072 9.45356 4.52662 9.62924 4.39586C9.80491 4.26509 10.0046 4.17023 10.217 4.1167L11.8337 3.7167C12.0465 3.66311 12.2679 3.65209 12.485 3.68428C12.7022 3.71647 12.9108 3.79124 13.099 3.90429C13.2871 4.01734 13.4511 4.16645 13.5815 4.34305C13.7118 4.51965 13.806 4.72026 13.8587 4.93337L14.2337 6.43337",
    stroke: "#020617",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduced);
export default __webpack_public_path__ + "static/media/produced.3a75ac6d7524355b62a57b9b33b7e328.svg";
export { ForwardRef as ReactComponent };